import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 952ADDE3-5EC1-4AB1-80F1-9FA7AA14AD74
 * name bank-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bank-outline.svg
 * tags
 * - Banking 
 */
export const BankOutlineIcon = createSvgIcon(<><path d="M6.5,10H4.5V17H6.5V10M12.5,10H10.5V17H12.5V10M21,19H2V21H21V19M18.5,10H16.5V17H18.5V10M11.5,3.26L16.71,6H6.29L11.5,3.26M11.5,1L2,6V8H21V6L11.5,1Z" /></>, 'BankOutlineIcon');
export default BankOutlineIcon